export default __webpack_public_path__ + "static/media/bg_dark.234bbc47.jpg";